import type { RouteObject } from "react-router";
import { Uebersicht } from "./Uebersicht";
import { Deals } from "./Deals";
import { DealDetail } from "./DealDetail";
import { MeineMarken } from "./MeineMarken";
import { Rechnungen } from "./Rechnungen";
import { RechnungEinreichen } from "./RechnungEinreichen";
import { Profil } from "./Profil";
import { Instagram } from "./Instagram";
import { Einladung } from "./Einladung";
import { Mehr } from "./Mehr";
import { Abmelden, Konto } from "./Konto";
import { Scoped } from "./ui";
import { MeineVertraege } from "./vertraege/MeineVertraege";
import { MeinVertrag } from "./vertraege/MeinVertrag";

/**
 * Wege des Creator-Portals. Jede Seite hängt am gewählten Talent-Datensatz (Scoped): ein Agenturwechsel baut sie neu auf.
 * Bei einer früheren Agentur (archiviertes Profil) sind nur Rechnungen, Verträge und das Konto erreichbar (archivedOk).
 * Alle Wege stehen unter dem gemeinsamen Rahmen (rahmen.tsx), auch die der Kommunikation.
 * Sprungziele für Mails und Glocke: /creator/rechnungen?rechnung=<id>, /creator/rechnungen/einreichen?rechnung=<id> (Korrektur),
 * /creator/rechnungen/einreichen?kooperation=<id>&monat=YYYY-MM (angeforderter Monat), /creator/deals/<id>?monat=YYYY-MM,
 * /creator/instagram?ticket=<ticket> (Rücklauf der Instagram-Anmeldung).
 */
export const creatorRoutes: RouteObject[] = [
  { index: true, element: <Scoped page={Uebersicht} /> },
  { path: "deals", element: <Scoped page={Deals} /> },
  { path: "deals/:dealId", element: <Scoped page={DealDetail} /> },
  // Hub (21.10.2026): eigene Deals je Marke mit dem Stand von Vertrag, Content und Rechnung
  { path: "marken", element: <Scoped page={MeineMarken} /> },
  { path: "rechnungen", element: <Scoped page={Rechnungen} archivedOk /> },
  { path: "rechnungen/einreichen", element: <Scoped page={RechnungEinreichen} /> },
  { path: "vertraege", element: <Scoped page={MeineVertraege} archivedOk /> },
  { path: "vertraege/:contractId", element: <Scoped page={MeinVertrag} archivedOk /> },
  { path: "profil", element: <Scoped page={Profil} /> },
  { path: "instagram", element: <Scoped page={Instagram} /> },
  { path: "mehr", element: <Scoped page={Mehr} /> },
  // Konto und Sicherheit, Abmelden: an allen Größen und auch im Archiv (Befunde 3 und 4)
  { path: "konto", element: <Scoped page={Konto} archivedOk /> },
  { path: "abmelden", element: <Abmelden /> },
];

/** Einladung annehmen (öffentlich erreichbar, Anmeldung folgt im Ablauf). Der Mail-Link lautet /einladung?t=<token> (0025). */
export const creatorPublicRoutes: RouteObject[] = [
  { path: "/einladung/:token", element: <Einladung /> },
  { path: "/einladung", element: <Einladung /> },
];
